<template>
    <div class="layout-border-panel">
        <div class="editor-attr-props-content">
            <span class="attr-label">标题:</span>
            <div class="attr-content">
                <TextProp v-model="title" @save="changed"></TextProp>
            </div>
        </div>
        <template v-if="metadata&&metadata.props&&config.props">
            <div class="editor-attr-props-content" v-for="prop of metadata.props" :key="prop.name">
                <span class="attr-label">{{prop.title}}：</span>
                <div class="attr-content">
                    <FontProp v-if="prop.type.name==='font'" v-model="config.props[prop.name]" @save="save"></FontProp>
                    <BoolProp v-if="prop.type.name==='bool'" v-model="config.props[prop.name]" @save="save"></BoolProp>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import FontProp from '././../common-prop-editor/font-prop.vue';
import TextProp from '././../common-prop-editor/text-prop.vue';
import BoolProp from '././../common-prop-editor/bool-prop.vue';
import Vue from 'vue';

export default {
    props:[
        "config", "metadata", "value"
    ],
    data() {
        return {
            title:''
        }
    },
    components:{
        FontProp, 
        TextProp,
        BoolProp
    },
    watch:{
        config:{
            handler(){
                if(this.config&&!this.config.props){
                this.config.props = {};
                }
                if(this.metadata&&this.metadata.props){
                    for (let i = 0; i < this.metadata.props.length; i++) {
                        const prop = this.metadata.props[i];
                        if(!(prop.name in this.config.props)){
                            // 深拷贝数据,  锁定数据，使其不可改变
                            if(prop.default!==undefined){
                                if(typeof prop.default === 'object'){
                                    Vue.set(this.config.props, prop.name, Object.freeze(JSON.parse(JSON.stringify(prop.default))));
                                }else{
                                    Vue.set(this.config.props, prop.name,  prop.default);
                                }
                            }
                        }
                    }
                }
            },
            immediate:true
        },

        value:{
            handler(){
                this.title = this.value;
            },
            immediate:true
        }
        
    },
    methods: {
        save(){
            this.$emit("save");
        },
        changed(){
            this.$emit('input', this.title);
            this.save();
        }
    },
}
</script>